import BaseQuizGame from "./BaseQuizGame.js";
import { getFlagPath } from "../utils/FlagUtils.js";
import { readZone, scopedGameId, renderZoneBar } from "../utils/ZoneScope.js";

export default class CapitalNerdClassic extends BaseQuizGame {
	constructor() {
		const zone = readZone();
		super(scopedGameId('capitalnerd', zone), '.capital-nerd-classic', {
			passportStamp: "capital",
			gameNameKey: "home.capitalNerd",
			modeLabelKey: "home.classic",
			mode: "classic",
			shareEmoji: "🟦",
			slug: zone ? `capital-nerd-classic?zone=${zone}` : "capital-nerd-classic",
			zoneKey: zone ? `mapExploration.continents.${zone}` : null
		});
		if (!this.page) return;
		this.zone = zone;
		renderZoneBar(this.page, zone);

		this.init();
	}

	buildProposalEntry(country) {
		return { code: country.code, name: country.name, capital: country.capital };
	}

	renderQuestion(country) {
		return `
			<div class="flag" style="background-image: url(${getFlagPath(country.code)})"></div>
			<div class="name">${country.name}</div>
		`;
	}

	getAnswerLabel(proposal) {
		return proposal.capital;
	}

	buildError(guessBtn) {
		return {
			countryName: this.rightAnswer.name,
			correctCode: this.rightAnswer.code,
			correctCapital: this.rightAnswer.capital,
			guessedCapital: guessBtn.textContent
		};
	}

	renderErrorItem(error) {
		return `
			<div class="error-item">
				<div class="error-country">${error.countryName}</div>
				<div class="error-flag correct">
					<img src="${getFlagPath(error.correctCode)}" alt="${error.countryName}">
				</div>
				<div class="error-details">
					<div class="error-answer-text correct">${error.correctCapital}</div>
					<div class="error-answer-text wrong">${error.guessedCapital}</div>
				</div>
			</div>
		`;
	}
}
